<template>
    <div class="container-fluid bg" v-lazy:background-image="imgObj">
        <div class="row full-height d-flex justify-content-center align-items-center">
            <div class="col-12 col-md-6 col-lg-4 col-xl-4">
                <div class="text-xs-center animated fadeInUp login-logo d-flex justify-content-center" >
                    <i class=" d-block m-auto icon-login-logo icon-cph_iconset_cph_logo_claim01"></i>
                </div>
                <section class="form-box animated mt-4">
                    <router-view></router-view>
                </section>
            </div>
        </div>
        <privacy></privacy>
    </div>
</template>

<script type="text/babel">
import Privacy from '../../components/Auth/Login/Privacy'

export default {
    name: 'Auth',
    components: {
        Privacy
    },
    data () {
        return {
            errorMessage: '',
            imgObj: {
                src: '/static/backgrounds/cph_bg.jpg',
                error: '/static/images/error-image.jpg',
                loading: '/static/backgrounds/cph_bg-sm.jpg'
            }
        };
    }
};

</script>

<style lang="scss">
    .create-new-account-link {
        width: 100%;
    }
    
    .form-box {
        @include color('background-color', background-color-light);
        padding: 25px;
        border-radius: 10px;
    }
    
    .icon-login-logo {
        font-size: 300px;
        @include color('color', text-color-light);
    }
    
    .login-button {
        padding: 5px 38px;
        @include color('background-color', primary);
        @include color('color', text-color-light);
        &:hover {
            @include color('background-color', primary-active);
            @include color('color', text-color-light);
        }
    }
    
    .login-form > .form.control {
        input {
            font-size: 13px;
            border: none;
            @include color('background-color', secondary);
        }
    }
    
    
    @media (max-width: 600px) {
        .icon-login-logo {
            font-size: 250px;
            @include color('color', text-color-light);
            }
        
        .login-logo {
            margin-bottom: 30px;
        }
    }
    
    .create-account {
        @include color('color', text-color-light);
        text-align: center;
        width: 100%;
        opacity: 0.8;
    }
    
    .keep-signed-label {
        color: #b8b8b8;
    }
    
    .error-msg {
        color: #d50000;
        padding: 10px 0 0 10px;
    }
    
    div.container-fluid {
        margin-bottom: 0 !important;
    }
    .bg {
        /* The image used */
        background: no-repeat center center fixed;
        /* Full height */
        min-height: 100vh;
        height: 100%;
        /* Center and scale the image nicely */
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        overflow: hidden;
    }
    
    .full-height {
        min-height: 100vh;
        height: 100%;
    }

</style>
